import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '@/logic/break/BreakUtils';

registerCollisionAnimation('CRYSTAL_SHARDS', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  for (let i = 0; i < 10; i++) {
    const rnd = seedRandom(e.id, i);
    const angle = rnd * Math.PI * 2;
    const dist = progress * 100;
    const cx = e.pos.x + Math.cos(angle) * dist;
    const cy = e.pos.y + Math.sin(angle) * dist;

    ctx.fillStyle = determineColor(i, 10);
    ctx.globalAlpha = 1 - progress;
    ctx.save(); ctx.translate(cx, cy); ctx.rotate(angle + progress);
    ctx.beginPath(); ctx.moveTo(0, -10); ctx.lineTo(5, 0); ctx.lineTo(0, 10); ctx.lineTo(-5, 0); ctx.fill();
    ctx.restore();
  }
});
